import { Flex, Heading, VStack } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Loader from "../../utils/Loader/Loader";
import PaginationSizeSelect from "../../utils/Loader/PaginationSizeSelect";
import Paginator from "../../utils/Loader/Paginator";
import Layout from "../Layout/Layout";
import ContactSyncTable from "./ContactSyncTable";
import LogDeleteAlert from "./LogDeleteAlert";
import LogJsonModal from "./LogJsonModal";
import NoLogsFound from "./NoLogsFound";
import ShowModal from "./ShowModal";
import SystemLogTable from "./SystemLogTable";
import ToolFunctionInvokeLogs from "./ToolFunctionInvokeLogs";
import useLogs from "./useLogs";
import useSelectedLog from "./useSelectedLog";

export default function LogsWrapper() {
  const { selectedLogType = "user_log" } = useParams();

  const logTypes = {
    system_log: {
      value: "user_log",
      Table: SystemLogTable,
      heading: "System Logs",
    },
    tool_function_invoke_log: {
      value: "tool_function_invoke_log",
      Table: ToolFunctionInvokeLogs,
      heading: "Tool Function Calls",
    },
    contact_sync_log: {
      value: "contact_sync_log",
      Table: ContactSyncTable,
      heading: "Contact Sync",
    },
  };

  const {
    selectedLog,
    isShowModalOpen,
    onCloseShowModal,
    onOpenShowModal,
    selectedJson,
    onOpenCallDetailsModal,
    onCloseCallDetailsModal,
    isCallDetailsModal,
    isDeleteAlertOpen,
    closeDeleteAlert,
    onDeleteLog,
  } = useSelectedLog({ selectedLogType });

  const {
    paginator,
    response,
    isLoading,
    deleteLog,
    status,
    paginationSize,
    setPaginationSize,
    onSetResponse,
    onSetStatus,
  } = useLogs({
    logType: selectedLogType,
    closeDeleteAlert,
    logTypes,
  });
  const totalPages = response?.data?.pages;
  const logs = response?.data?.items || [];

  useEffect(() => {
    paginator.onSetPage(1);
    onSetStatus("loading");
    onSetResponse(null);
  }, []);

  const defaultLog = Object.keys(logTypes).find((log) => {
    if (log === selectedLogType) {
      return logTypes[log];
    }
    return null;
  });

  const { Table: SelectedTable, tableProps } = logTypes[defaultLog];

  return (
    <>
       <VStack
        h="100%"
        spacing={2}
        justifyContent={"space-between"}
        borderRadius="md"
      >
        <Flex direction={"column"} gap={3} h={"95%"} w={"100%"}>
          <Flex gap={2} w={"100%"} alignItems="center" p={2}>
            <Heading color={"#3182ce"} fontSize="xl">
              {logTypes[defaultLog].heading}
            </Heading>
          </Flex>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {logs.length ? (
                <SelectedTable
                  logs={logs}
                  onOpenCallDetailsModal={onOpenCallDetailsModal}
                  onOpenShowModal={onOpenShowModal}
                  onDeleteLog={onDeleteLog}
                  tableProps={tableProps}
                  isCallDetailsModal={isCallDetailsModal}
                  onCloseCallDetailsModal={onCloseCallDetailsModal}
                />
              ) : (
                <NoLogsFound />
              )}
            </>
          )}
        </Flex>

        {logs.length && (
          <Flex
            justifyContent={"flex-end"}
            alignItems={"center"}
            gap={2}
            w={"100%"}
          >
            <PaginationSizeSelect
              paginationSize={paginationSize}
              setPaginationSize={setPaginationSize}
              tableLength={logs.length}
            />
            <Paginator
              onChangePage={paginator.onSetPage}
              page={paginator.page}
              pages={totalPages}
            />
          </Flex>
        )}
      </VStack>

      {selectedLog && isShowModalOpen ? (
        <ShowModal
          selectedLog={selectedLog}
          isOpen={isShowModalOpen}
          onClose={onCloseShowModal}
        />
      ) : null}
      {selectedJson && isCallDetailsModal ? (
        <LogJsonModal
          isOpen={isCallDetailsModal}
          onClose={onCloseCallDetailsModal}
          selectedJson={selectedJson}
        />
      ) : null}
      {selectedLog && isDeleteAlertOpen ? (
        <LogDeleteAlert
          isOpen={isDeleteAlertOpen}
          onClose={closeDeleteAlert}
          selectedLog={selectedLog}
          onConfirmDelete={deleteLog}
          status={status}
        />
      ) : null}
    </>
   
  );
}
